import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

export default function Auth() {
  const [mode, setMode]         = useState('choose');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [sent, setSent]         = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  const handleMagicLink = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true); setError('');
    const { error } = await supabase.auth.signInWithOtp({
      email: email.trim().toLowerCase(),
      options: { emailRedirectTo: window.location.origin },
    });
    if (error) setError(error.message);
    else setSent(true);
    setLoading(false);
  };

  const handlePassword = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setLoading(true); setError('');
    const { error } = await supabase.auth.signInWithPassword({
      email: email.trim().toLowerCase(),
      password,
    });
    if (error) setError(
      error.message === 'Invalid login credentials'
        ? 'Incorrect email or password. Try a magic link instead.'
        : error.message
    );
    setLoading(false);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true); setError('');
    const { error } = await supabase.auth.resetPasswordForEmail(email.trim().toLowerCase(), {
      redirectTo: window.location.origin,
    });
    if (error) setError(error.message);
    else setSent(true);
    setLoading(false);
  };

  const handleGoogle = async () => {
    setLoading(true); setError('');
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin },
    });
    if (error) { setError(error.message); setLoading(false); }
  };

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.badge}>SALT Onboarding</div>
        <img src="/Camp_Phillip_Logo.png" alt="Camp Phillip" style={{ height: 60, margin: '4px auto 12px', display: 'block' }} />
        <p style={s.sub}>Sign in to complete your onboarding</p>

        {/* ── Choose method ── */}
        {mode === 'choose' && !sent && (
          <div>
            {/* Returning user — email + password */}
            <button style={s.primaryMethodBtn} onClick={() => { setMode('password'); setError(''); }}>
              🔑 Sign in with password
            </button>

            <Divider label="or sign in another way" />

            {/* Google */}
            <button style={s.googleBtn} onClick={handleGoogle} disabled={loading}>
              <GoogleIcon />
              {loading ? 'Redirecting…' : 'Continue with Google'}
            </button>

            {/* Magic link */}
            <button style={{ ...s.methodBtn, marginTop: 10 }} onClick={() => { setMode('magic'); setError(''); }}>
              ✨ Send me a magic link
            </button>

            {error && <p style={s.error}>{error}</p>}

            <p style={s.note}>First time? Check your email for an invite from Camp Phillip.</p>
          </div>
        )}

        {/* ── Magic link form ── */}
        {mode === 'magic' && !sent && (
          <form onSubmit={handleMagicLink} style={s.form}>
            <label style={s.label}>Your email address</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com" required style={s.input} autoFocus />
            {error && <p style={s.error}>{error}</p>}
            <button type="submit" disabled={loading} style={s.primaryBtn}>
              {loading ? 'Sending…' : '✨ Send magic link'}
            </button>
            <button type="button" style={s.backBtn} onClick={() => { setMode('choose'); setError(''); }}>← Back</button>
          </form>
        )}

        {/* ── Magic link sent ── */}
        {mode === 'magic' && sent && (
          <div style={s.sentBox}>
            <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>📬</div>
            <h2 style={s.sentTitle}>Check your email!</h2>
            <p style={s.sentText}>
              We sent a magic link to <strong>{email}</strong>.<br />
              Click the link to sign in — no password needed.
            </p>
            <p style={{ fontSize: '0.8rem', color: '#6B7F5A', marginTop: 12 }}>
              Didn't get it? Check spam or{' '}
              <button style={s.linkBtn} onClick={() => setSent(false)}>try again</button>.
            </p>
          </div>
        )}

        {/* ── Password form ── */}
        {mode === 'password' && (
          <form onSubmit={handlePassword} style={s.form}>
            <label style={s.label}>Email address</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com" required style={s.input} autoFocus />
            <label style={{ ...s.label, marginTop: 8 }}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="Your password" required style={s.input} />
            {error && <p style={s.error}>{error}</p>}
            <button type="submit" disabled={loading} style={s.primaryBtn}>
              {loading ? 'Signing in…' : '🔑 Sign in'}
            </button>
            <button type="button" style={s.backBtn}
              onClick={() => { setMode('choose'); setError(''); setPassword(''); }}>← Back</button>
            <p style={{ ...s.note, marginTop: 12 }}>
              <button type="button" style={s.linkBtn} onClick={() => { setMode('reset'); setError(''); setSent(false); }}>
                Forgot password?
              </button>
              {' · '}
              <button type="button" style={s.linkBtn} onClick={() => { setMode('magic'); setError(''); }}>
                Use a magic link instead
              </button>
            </p>
          </form>
        )}

        {/* ── Password reset form ── */}
        {mode === 'reset' && !sent && (
          <form onSubmit={handleReset} style={s.form}>
            <p style={{ ...s.note, marginTop: 0, marginBottom: 16, textAlign: 'left' }}>
              Enter your email and we'll send you a link to reset your password.
            </p>
            <label style={s.label}>Email address</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com" required style={s.input} autoFocus />
            {error && <p style={s.error}>{error}</p>}
            <button type="submit" disabled={loading} style={s.primaryBtn}>
              {loading ? 'Sending…' : '📧 Send reset link'}
            </button>
            <button type="button" style={s.backBtn}
              onClick={() => { setMode('password'); setError(''); }}>← Back</button>
          </form>
        )}

        {/* ── Reset link sent ── */}
        {mode === 'reset' && sent && (
          <div style={s.sentBox}>
            <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>📬</div>
            <h2 style={s.sentTitle}>Check your email!</h2>
            <p style={s.sentText}>
              We sent a password reset link to <strong>{email}</strong>.<br />
              Click the link in the email to set a new password.
            </p>
            <p style={{ fontSize: '0.8rem', color: '#6B7F5A', marginTop: 12 }}>
              Didn't get it? Check spam or{' '}
              <button style={s.linkBtn} onClick={() => setSent(false)}>try again</button>.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

function Divider({ label = 'or' }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '16px 0' }}>
      <div style={{ flex: 1, height: 1, background: '#C8D9B0' }} />
      <span style={{ fontSize: '0.8rem', color: '#6B7F5A', fontWeight: 600, whiteSpace: 'nowrap' }}>{label}</span>
      <div style={{ flex: 1, height: 1, background: '#C8D9B0' }} />
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" style={{ marginRight: 10, flexShrink: 0 }}>
      <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 002.38-5.88c0-.57-.05-.66-.15-1.18z"/>
      <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 01-7.18-2.54H1.83v2.07A8 8 0 008.98 17z"/>
      <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 010-3.04V5.41H1.83a8 8 0 000 7.18l2.67-2.07z"/>
      <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 001.83 5.4L4.5 7.49a4.77 4.77 0 014.48-3.31z"/>
    </svg>
  );
}

const s = {
  wrap: { minHeight: '100vh', backgroundImage: 'url(/camp_bg.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: "'Nunito', sans-serif" },
  card: { background: '#fff', borderRadius: 20, padding: '40px 36px', maxWidth: 420, width: '100%', textAlign: 'center', boxShadow: '0 8px 40px rgba(0,0,0,0.18)' },
  badge: { display: 'inline-block', background: '#F5A623', color: '#2D5016', fontWeight: 700, fontSize: '0.72rem', letterSpacing: 2, textTransform: 'uppercase', padding: '4px 14px', borderRadius: 20, marginBottom: 12 },
  title: { fontFamily: "'Playfair Display', serif", fontSize: '2rem', fontWeight: 900, color: '#2D5016', margin: '0 0 6px' },
  sub: { color: '#6B7F5A', fontSize: '0.95rem', marginBottom: 24 },
  primaryMethodBtn: { width: '100%', padding: '13px', background: '#2D5016', color: '#fff', border: 'none', borderRadius: 10, fontFamily: "'Nunito', sans-serif", fontSize: '1rem', fontWeight: 700, cursor: 'pointer', marginBottom: 0 },
  googleBtn: { width: '100%', padding: '12px 16px', background: '#fff', border: '2px solid #C8D9B0', borderRadius: 10, fontFamily: "'Nunito', sans-serif", fontSize: '0.95rem', fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1C2B0E' },
  methodBtn: { width: '100%', padding: '12px', background: '#F4F8EE', border: '2px solid #C8D9B0', borderRadius: 10, fontFamily: "'Nunito', sans-serif", fontSize: '0.95rem', fontWeight: 700, cursor: 'pointer', color: '#2D5016' },
  form: { textAlign: 'left' },
  label: { display: 'block', fontWeight: 700, fontSize: '0.88rem', color: '#2D5016', marginBottom: 6 },
  input: { width: '100%', padding: '11px 14px', border: '2px solid #C8D9B0', borderRadius: 8, fontFamily: "'Nunito', sans-serif", fontSize: '1rem', color: '#1C2B0E', outline: 'none', boxSizing: 'border-box', marginBottom: 8 },
  error: { color: '#C0392B', fontSize: '0.85rem', marginBottom: 8, textAlign: 'center' },
  primaryBtn: { width: '100%', padding: '13px', background: '#2D5016', color: '#fff', border: 'none', borderRadius: 10, fontFamily: "'Nunito', sans-serif", fontSize: '1rem', fontWeight: 700, cursor: 'pointer', marginTop: 4, marginBottom: 8 },
  backBtn: { width: '100%', padding: '10px', background: 'none', border: '2px solid #C8D9B0', borderRadius: 10, fontFamily: "'Nunito', sans-serif", fontSize: '0.9rem', fontWeight: 700, cursor: 'pointer', color: '#6B7F5A' },
  note: { color: '#6B7F5A', fontSize: '0.8rem', textAlign: 'center', lineHeight: 1.5, marginTop: 16 },
  sentBox: { textAlign: 'center', padding: '8px 0' },
  sentTitle: { fontFamily: "'Playfair Display', serif", color: '#2D5016', marginBottom: 8 },
  sentText: { color: '#444', lineHeight: 1.6, fontSize: '0.92rem' },
  linkBtn: { background: 'none', border: 'none', color: '#2E7DAF', cursor: 'pointer', fontWeight: 700, padding: 0, textDecoration: 'underline', fontFamily: "'Nunito', sans-serif", fontSize: 'inherit' },
};
